// extracted by mini-css-extract-plugin
export default {"root":"WastageComponentsPage_root__yroRk","image-results":"WastageComponentsPage_image-results__+yf1F","fallback":"WastageComponentsPage_fallback__NENXe"};